import { useState } from "react";
import { VideoModal } from "./VideoModal";

interface VideoThumbnailProps {
  thumbnailUrl: string;
  videoUrl: string;
  title?: string;
}

export function VideoThumbnail({ thumbnailUrl, videoUrl, title }: VideoThumbnailProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="group relative w-full aspect-[16/11] overflow-hidden border border-dark-foreground/10 bg-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-blood-red"
        aria-label={title ? `Play ${title} video` : "Play video"}
      >
        {/* Thumbnail Image */}
        <img
          src={thumbnailUrl}
          alt={title || "Video thumbnail"}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition-colors duration-300" />
        
        {/* Red top gradient on hover */}
        <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-blood-red/80 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 ease-out z-10" />
        
        {/* Play Button */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="relative w-20 h-20 md:w-24 md:h-24 flex items-center justify-center">
            {/* Outer ring */}
            <div className="absolute inset-0 border-2 border-white/50 group-hover:border-blood-red rounded-full transition-all duration-300 group-hover:scale-110" />
            {/* Inner circle */}
            <div className="absolute inset-2 bg-blood-red/80 group-hover:bg-blood-red rounded-full transition-all duration-300 group-hover:scale-105" />
            {/* Play icon */}
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              className="relative w-8 h-8 md:w-10 md:h-10 text-white ml-1"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      </button>
      
      <VideoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        videoUrl={videoUrl}
      />
    </>
  );
}